(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ll-catalog"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const btn = document.getElementById('catalog-view-more');
  const grid = document.getElementById('catalog-grid');
  if (!btn || !grid) return;

  btn.addEventListener('click', function () {
    const nextUrl = btn.getAttribute('data-next-page');

    if (!nextUrl) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    btn.textContent = 'Loading…';

    fetch(nextUrl)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newCards = doc.querySelectorAll('.catalog-card');
        newCards.forEach(card => grid.appendChild(card));

        const newBtn = doc.querySelector('#catalog-view-more');
        if (newBtn && newBtn.dataset.nextPage) {
          btn.dataset.nextPage = newBtn.dataset.nextPage;
          btn.textContent = 'View more colors';
        } else {
          btn.dataset.nextPage = '';
          btn.textContent = 'Back to Top';
          btn.classList.add('is-sticky');
        }
      });
  });
});

  } catch(e) { console.error(e); }
})();
})();
